import { render, staticRenderFns } from "./LaudoAgricola.vue?vue&type=template&id=91740c9a&scoped=true&lang=pug"
import script from "./LaudoAgricola.vue?vue&type=script&lang=js"
export * from "./LaudoAgricola.vue?vue&type=script&lang=js"
import style0 from "./LaudoAgricola.vue?vue&type=style&index=0&id=91740c9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91740c9a",
  null
  
)

export default component.exports